var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"torilive-app"},[_c('v-content',[_c('home')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }